export interface CountryType {
  code: string;
  label: string;
  phone: string;
  suggested?: boolean;
}
export interface CountryWithContentType {
  label: string;
  value: string;
  continent: string;
  isContinent: boolean;
}

export const countries: CountryType[] = [
  { code: "AD", label: "Andorra", phone: "376" },
  { code: "AF", label: "Afghanistan", phone: "93" },
  {
    code: "AG",
    label: "Antigua and Barbuda",
    phone: "1-268",
  },
  { code: "AI", label: "Anguilla", phone: "1-264" },
  { code: "AL", label: "Albania", phone: "355" },
  { code: "AM", label: "Armenia", phone: "374" },
  { code: "AO", label: "Angola", phone: "244" },
  { code: "AQ", label: "Antarctica", phone: "672" },
  { code: "AR", label: "Argentina", phone: "54" },
  { code: "AS", label: "American Samoa", phone: "1-684" },
  { code: "AT", label: "Austria", phone: "43" },
  {
    code: "AU",
    label: "Australia",
    phone: "61",
    suggested: true,
  },
  { code: "AW", label: "Aruba", phone: "297" },
  { code: "AX", label: "Alland Islands", phone: "358" },
  { code: "AZ", label: "Azerbaijan", phone: "994" },
  {
    code: "BA",
    label: "Bosnia and Herzegovina",
    phone: "387",
  },
  { code: "BB", label: "Barbados", phone: "1-246" },
  { code: "BD", label: "Bangladesh", phone: "880" },
  { code: "BE", label: "Belgium", phone: "32" },
  { code: "BF", label: "Burkina Faso", phone: "226" },
  { code: "BG", label: "Bulgaria", phone: "359" },
  { code: "BH", label: "Bahrain", phone: "973" },
  { code: "BI", label: "Burundi", phone: "257" },
  { code: "BJ", label: "Benin", phone: "229" },
  { code: "BL", label: "Saint Barthelemy", phone: "590" },
  { code: "BM", label: "Bermuda", phone: "1-441" },
  { code: "BN", label: "Brunei Darussalam", phone: "673" },
  { code: "BO", label: "Bolivia", phone: "591" },
  { code: "BR", label: "Brazil", phone: "55" },
  { code: "BS", label: "Bahamas", phone: "1-242" },
  { code: "BT", label: "Bhutan", phone: "975" },
  { code: "BV", label: "Bouvet Island", phone: "47" },
  { code: "BW", label: "Botswana", phone: "267" },
  { code: "BY", label: "Belarus", phone: "375" },
  { code: "BZ", label: "Belize", phone: "501" },
  {
    code: "CA",
    label: "Canada",
    phone: "1",
    suggested: true,
  },
  {
    code: "CC",
    label: "Cocos (Keeling) Islands",
    phone: "61",
  },
  {
    code: "CD",
    label: "Democratic Republic of the Congo",
    phone: "243",
  },
  {
    code: "CF",
    label: "Central African Republic",
    phone: "236",
  },
  {
    code: "CG",
    label: "Republic of the Congo",
    phone: "242",
  },
  { code: "CH", label: "Switzerland", phone: "41" },
  { code: "CI", label: "Cote d'Ivoire", phone: "225" },
  { code: "CK", label: "Cook Islands", phone: "682" },
  { code: "CL", label: "Chile", phone: "56" },
  { code: "CM", label: "Cameroon", phone: "237" },
  { code: "CN", label: "China", phone: "86" },
  { code: "CO", label: "Colombia", phone: "57" },
  { code: "CR", label: "Costa Rica", phone: "506" },
  { code: "CU", label: "Cuba", phone: "53" },
  { code: "CV", label: "Cape Verde", phone: "238" },
  { code: "CW", label: "Curacao", phone: "599" },
  { code: "CX", label: "Christmas Island", phone: "61" },
  { code: "CY", label: "Cyprus", phone: "357" },
  { code: "CZ", label: "Czech Republic", phone: "420" },
  {
    code: "DE",
    label: "Germany",
    phone: "49",
    suggested: true,
  },
  { code: "DJ", label: "Djibouti", phone: "253" },
  { code: "DK", label: "Denmark", phone: "45" },
  { code: "DM", label: "Dominica", phone: "1-767" },
  {
    code: "DO",
    label: "Dominican Republic",
    phone: "1-809",
  },
  { code: "DZ", label: "Algeria", phone: "213" },
  { code: "EC", label: "Ecuador", phone: "593" },
  { code: "EE", label: "Estonia", phone: "372" },
  { code: "EG", label: "Egypt", phone: "20" },
  { code: "EH", label: "Western Sahara", phone: "212" },
  { code: "ER", label: "Eritrea", phone: "291" },
  { code: "ES", label: "Spain", phone: "34" },
  { code: "ET", label: "Ethiopia", phone: "251" },
  { code: "FI", label: "Finland", phone: "358" },
  { code: "FJ", label: "Fiji", phone: "679" },
  {
    code: "FK",
    label: "Falkland Islands (Malvinas)",
    phone: "500",
  },
  {
    code: "FM",
    label: "Micronesia, Federated States of",
    phone: "691",
  },
  { code: "FO", label: "Faroe Islands", phone: "298" },
  {
    code: "FR",
    label: "France",
    phone: "33",
    suggested: true,
  },
  { code: "GA", label: "Gabon", phone: "241" },
  { code: "GB", label: "United Kingdom", phone: "44" },
  { code: "GD", label: "Grenada", phone: "1-473" },
  { code: "GE", label: "Georgia", phone: "995" },
  { code: "GF", label: "French Guiana", phone: "594" },
  { code: "GG", label: "Guernsey", phone: "44" },
  { code: "GH", label: "Ghana", phone: "233" },
  { code: "GI", label: "Gibraltar", phone: "350" },
  { code: "GL", label: "Greenland", phone: "299" },
  { code: "GM", label: "Gambia", phone: "220" },
  { code: "GN", label: "Guinea", phone: "224" },
  { code: "GP", label: "Guadeloupe", phone: "590" },
  { code: "GQ", label: "Equatorial Guinea", phone: "240" },
  { code: "GR", label: "Greece", phone: "30" },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
    phone: "500",
  },
  { code: "GT", label: "Guatemala", phone: "502" },
  { code: "GU", label: "Guam", phone: "1-671" },
  { code: "GW", label: "Guinea-Bissau", phone: "245" },
  { code: "GY", label: "Guyana", phone: "592" },
  { code: "HK", label: "Hong Kong", phone: "852" },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands",
    phone: "672",
  },
  { code: "HN", label: "Honduras", phone: "504" },
  { code: "HR", label: "Croatia", phone: "385" },
  { code: "HT", label: "Haiti", phone: "509" },
  { code: "HU", label: "Hungary", phone: "36" },
  { code: "ID", label: "Indonesia", phone: "62" },
  { code: "IE", label: "Ireland", phone: "353" },
  { code: "IL", label: "Israel", phone: "972" },
  { code: "IM", label: "Isle of Man", phone: "44" },
  { code: "IN", label: "India", phone: "91" },
  {
    code: "IO",
    label: "British Indian Ocean Territory",
    phone: "246",
  },
  { code: "IQ", label: "Iraq", phone: "964" },
  {
    code: "IR",
    label: "Iran, Islamic Republic of",
    phone: "98",
  },
  { code: "IS", label: "Iceland", phone: "354" },
  { code: "IT", label: "Italy", phone: "39" },
  { code: "JE", label: "Jersey", phone: "44" },
  { code: "JM", label: "Jamaica", phone: "1-876" },
  { code: "JO", label: "Jordan", phone: "962" },
  {
    code: "JP",
    label: "Japan",
    phone: "81",
    suggested: true,
  },
  { code: "KE", label: "Kenya", phone: "254" },
  { code: "KG", label: "Kyrgyzstan", phone: "996" },
  { code: "KH", label: "Cambodia", phone: "855" },
  { code: "KI", label: "Kiribati", phone: "686" },
  { code: "KM", label: "Comoros", phone: "269" },
  {
    code: "KN",
    label: "Saint Kitts and Nevis",
    phone: "1-869",
  },
  {
    code: "KP",
    label: "Korea, Democratic People's Republic of",
    phone: "850",
  },
  { code: "KR", label: "Korea, Republic of", phone: "82" },
  { code: "KW", label: "Kuwait", phone: "965" },
  { code: "KY", label: "Cayman Islands", phone: "1-345" },
  { code: "KZ", label: "Kazakhstan", phone: "7" },
  {
    code: "LA",
    label: "Lao People's Democratic Republic",
    phone: "856",
  },
  { code: "LB", label: "Lebanon", phone: "961" },
  { code: "LC", label: "Saint Lucia", phone: "1-758" },
  { code: "LI", label: "Liechtenstein", phone: "423" },
  { code: "LK", label: "Sri Lanka", phone: "94" },
  { code: "LR", label: "Liberia", phone: "231" },
  { code: "LS", label: "Lesotho", phone: "266" },
  { code: "LT", label: "Lithuania", phone: "370" },
  { code: "LU", label: "Luxembourg", phone: "352" },
  { code: "LV", label: "Latvia", phone: "371" },
  { code: "LY", label: "Libya", phone: "218" },
  { code: "MA", label: "Morocco", phone: "212" },
  { code: "MC", label: "Monaco", phone: "377" },
  {
    code: "MD",
    label: "Moldova, Republic of",
    phone: "373",
  },
  { code: "ME", label: "Montenegro", phone: "382" },
  {
    code: "MF",
    label: "Saint Martin (French part)",
    phone: "590",
  },
  { code: "MG", label: "Madagascar", phone: "261" },
  { code: "MH", label: "Marshall Islands", phone: "692" },
  {
    code: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
    phone: "389",
  },
  { code: "ML", label: "Mali", phone: "223" },
  { code: "MM", label: "Myanmar", phone: "95" },
  { code: "MN", label: "Mongolia", phone: "976" },
  { code: "MO", label: "Macao", phone: "853" },
  {
    code: "MP",
    label: "Northern Mariana Islands",
    phone: "1-670",
  },
  { code: "MQ", label: "Martinique", phone: "596" },
  { code: "MR", label: "Mauritania", phone: "222" },
  { code: "MS", label: "Montserrat", phone: "1-664" },
  { code: "MT", label: "Malta", phone: "356" },
  { code: "MU", label: "Mauritius", phone: "230" },
  { code: "MV", label: "Maldives", phone: "960" },
  { code: "MW", label: "Malawi", phone: "265" },
  { code: "MX", label: "Mexico", phone: "52" },
  { code: "MY", label: "Malaysia", phone: "60" },
  { code: "MZ", label: "Mozambique", phone: "258" },
  { code: "NA", label: "Namibia", phone: "264" },
  { code: "NC", label: "New Caledonia", phone: "687" },
  { code: "NE", label: "Niger", phone: "227" },
  { code: "NF", label: "Norfolk Island", phone: "672" },
  { code: "NG", label: "Nigeria", phone: "234" },
  { code: "NI", label: "Nicaragua", phone: "505" },
  { code: "NL", label: "Netherlands", phone: "31" },
  { code: "NO", label: "Norway", phone: "47" },
  { code: "NP", label: "Nepal", phone: "977" },
  { code: "NR", label: "Nauru", phone: "674" },
  { code: "NU", label: "Niue", phone: "683" },
  { code: "NZ", label: "New Zealand", phone: "64" },
  { code: "OM", label: "Oman", phone: "968" },
  { code: "PA", label: "Panama", phone: "507" },
  { code: "PE", label: "Peru", phone: "51" },
  { code: "PF", label: "French Polynesia", phone: "689" },
  { code: "PG", label: "Papua New Guinea", phone: "675" },
  { code: "PH", label: "Philippines", phone: "63" },
  { code: "PK", label: "Pakistan", phone: "92" },
  { code: "PL", label: "Poland", phone: "48" },
  {
    code: "PM",
    label: "Saint Pierre and Miquelon",
    phone: "508",
  },
  { code: "PN", label: "Pitcairn", phone: "870" },
  { code: "PR", label: "Puerto Rico", phone: "1" },
  {
    code: "PS",
    label: "Palestine, State of",
    phone: "970",
  },
  { code: "PT", label: "Portugal", phone: "351" },
  { code: "PW", label: "Palau", phone: "680" },
  { code: "PY", label: "Paraguay", phone: "595" },
  { code: "QA", label: "Qatar", phone: "974" },
  { code: "RE", label: "Reunion", phone: "262" },
  { code: "RO", label: "Romania", phone: "40" },
  { code: "RS", label: "Serbia", phone: "381" },
  { code: "RU", label: "Russian Federation", phone: "7" },
  { code: "RW", label: "Rwanda", phone: "250" },
  { code: "SA", label: "Saudi Arabia", phone: "966" },
  { code: "SB", label: "Solomon Islands", phone: "677" },
  { code: "SC", label: "Seychelles", phone: "248" },
  { code: "SD", label: "Sudan", phone: "249" },
  { code: "SE", label: "Sweden", phone: "46" },
  { code: "SG", label: "Singapore", phone: "65" },
  { code: "SH", label: "Saint Helena", phone: "290" },
  { code: "SI", label: "Slovenia", phone: "386" },
  {
    code: "SJ",
    label: "Svalbard and Jan Mayen",
    phone: "47",
  },
  { code: "SK", label: "Slovakia", phone: "421" },
  { code: "SL", label: "Sierra Leone", phone: "232" },
  { code: "SM", label: "San Marino", phone: "378" },
  { code: "SN", label: "Senegal", phone: "221" },
  { code: "SO", label: "Somalia", phone: "252" },
  { code: "SR", label: "Suriname", phone: "597" },
  { code: "SS", label: "South Sudan", phone: "211" },
  {
    code: "ST",
    label: "Sao Tome and Principe",
    phone: "239",
  },
  { code: "SV", label: "El Salvador", phone: "503" },
  {
    code: "SX",
    label: "Sint Maarten (Dutch part)",
    phone: "1-721",
  },
  {
    code: "SY",
    label: "Syrian Arab Republic",
    phone: "963",
  },
  { code: "SZ", label: "Swaziland", phone: "268" },
  {
    code: "TC",
    label: "Turks and Caicos Islands",
    phone: "1-649",
  },
  { code: "TD", label: "Chad", phone: "235" },
  {
    code: "TF",
    label: "French Southern Territories",
    phone: "262",
  },
  { code: "TG", label: "Togo", phone: "228" },
  { code: "TH", label: "Thailand", phone: "66" },
  { code: "TJ", label: "Tajikistan", phone: "992" },
  { code: "TK", label: "Tokelau", phone: "690" },
  { code: "TL", label: "Timor-Leste", phone: "670" },
  { code: "TM", label: "Turkmenistan", phone: "993" },
  { code: "TN", label: "Tunisia", phone: "216" },
  { code: "TO", label: "Tonga", phone: "676" },
  { code: "TR", label: "Turkey", phone: "90" },
  {
    code: "TT",
    label: "Trinidad and Tobago",
    phone: "1-868",
  },
  { code: "TV", label: "Tuvalu", phone: "688" },
  {
    code: "TW",
    label: "Taiwan",
    phone: "886",
  },
  {
    code: "TZ",
    label: "United Republic of Tanzania",
    phone: "255",
  },
  { code: "UA", label: "Ukraine", phone: "380" },
  {
    code: "AE",
    label: "United Arab Emirates",
    phone: "971",
  },
  { code: "UG", label: "Uganda", phone: "256" },
  { code: "US", label: "United States", phone: "1", suggested: true },
  { code: "UY", label: "Uruguay", phone: "598" },
  { code: "UZ", label: "Uzbekistan", phone: "998" },
  {
    code: "VA",
    label: "Holy See (Vatican City State)",
    phone: "379",
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
    phone: "1-784",
  },
  { code: "VE", label: "Venezuela", phone: "58" },
  {
    code: "VG",
    label: "British Virgin Islands",
    phone: "1-284",
  },
  {
    code: "VI",
    label: "US Virgin Islands",
    phone: "1-340",
  },
  { code: "VN", label: "Vietnam", phone: "84" },
  { code: "VU", label: "Vanuatu", phone: "678" },
  { code: "WF", label: "Wallis and Futuna", phone: "681" },
  { code: "WS", label: "Samoa", phone: "685" },
  { code: "XK", label: "Kosovo", phone: "383" },
  { code: "YE", label: "Yemen", phone: "967" },
  { code: "YT", label: "Mayotte", phone: "262" },
  { code: "ZA", label: "South Africa", phone: "27" },
  { code: "ZM", label: "Zambia", phone: "260" },
  { code: "ZW", label: "Zimbabwe", phone: "263" },
];

export const countriesWithContinents = [
  // Asia
  {
    label: "Asia",
    continent: "Asia",
    isContinent: true,
    value: "Asia",
  },
  {
    label: "Afghanistan",
    continent: "Asia",
    isContinent: false,
    value: "Afghanistan",
  },
  {
    label: "Armenia",
    continent: "Asia",
    isContinent: false,
    value: "Armenia",
  },
  {
    label: "Azerbaijan",
    continent: "Asia",
    isContinent: false,
    value: "Azerbaijan",
  },
  {
    label: "Bahrain",
    continent: "Asia",
    isContinent: false,
    value: "Bahrain",
  },
  {
    label: "Bangladesh",
    continent: "Asia",
    isContinent: false,
    value: "Bangladesh",
  },
  {
    label: "Bhutan",
    continent: "Asia",
    isContinent: false,
    value: "Bhutan",
  },
  {
    label: "Brunei Darussalam",
    continent: "Asia",
    isContinent: false,
    value: "Brunei Darussalam",
  },
  {
    label: "Cambodia",
    continent: "Asia",
    isContinent: false,
    value: "Cambodia",
  },
  {
    label: "China",
    continent: "Asia",
    isContinent: false,
    value: "China",
  },
  {
    label: "Georgia",
    continent: "Asia",
    isContinent: false,
    value: "Georgia",
  },
  {
    label: "Hong Kong",
    continent: "Asia",
    isContinent: false,
    value: "Hong Kong",
  },
  {
    label: "India",
    continent: "Asia",
    isContinent: false,
    value: "India",
  },
  {
    label: "Indonesia",
    continent: "Asia",
    isContinent: false,
    value: "Indonesia",
  },
  {
    label: "Iran, Islamic Republic of",
    continent: "Asia",
    isContinent: false,
    value: "Iran, Islamic Republic of",
  },
  {
    label: "Iraq",
    continent: "Asia",
    isContinent: false,
    value: "Iraq",
  },
  {
    label: "Israel",
    continent: "Asia",
    isContinent: false,
    value: "Israel",
  },
  {
    label: "Japan",
    suggested: true,
    continent: "Asia",
    isContinent: false,
    value: "Japan",
  },
  {
    label: "Jordan",
    continent: "Asia",
    isContinent: false,
    value: "Jordan",
  },
  {
    label: "Kazakhstan",
    continent: "Asia",
    isContinent: false,
    value: "Kazakhstan",
  },
  {
    label: "Korea, Democratic People's Republic of",
    continent: "Asia",
    isContinent: false,
    value: "Korea, Democratic People's Republic of",
  },
  {
    label: "Korea, Republic of",
    continent: "Asia",
    isContinent: false,
    value: "Korea, Republic of",
  },
  {
    label: "Kuwait",
    continent: "Asia",
    isContinent: false,
    value: "Kuwait",
  },
  {
    label: "Kyrgyzstan",
    continent: "Asia",
    isContinent: false,
    value: "Kyrgyzstan",
  },
  {
    label: "Lao People's Democratic Republic",
    continent: "Asia",
    isContinent: false,
    value: "Lao People's Democratic Republic",
  },
  {
    label: "Lebanon",
    continent: "Asia",
    isContinent: false,
    value: "Lebanon",
  },
  {
    label: "Macao",
    continent: "Asia",
    isContinent: false,
    value: "Macao",
  },
  {
    label: "Malaysia",
    continent: "Asia",
    isContinent: false,
    value: "Malaysia",
  },
  {
    label: "Maldives",
    continent: "Asia",
    isContinent: false,
    value: "Maldives",
  },
  {
    label: "Mongolia",
    continent: "Asia",
    isContinent: false,
    value: "Mongolia",
  },
  {
    label: "Myanmar",
    continent: "Asia",
    isContinent: false,
    value: "Myanmar",
  },
  {
    label: "Nepal",
    continent: "Asia",
    isContinent: false,
    value: "Nepal",
  },
  {
    label: "Oman",
    continent: "Asia",
    isContinent: false,
    value: "Oman",
  },
  {
    label: "Pakistan",
    continent: "Asia",
    isContinent: false,
    value: "Pakistan",
  },
  {
    label: "Palestine, State of",
    continent: "Asia",
    isContinent: false,
    value: "Palestine",
  },
  {
    label: "Philippines",
    continent: "Asia",
    isContinent: false,
    value: "Philippines",
  },
  {
    label: "Qatar",
    continent: "Asia",
    isContinent: false,
    value: "Qatar",
  },
  {
    label: "Saudi Arabia",
    continent: "Asia",
    isContinent: false,
    value: "Saudi Arabia",
  },
  {
    label: "Singapore",
    continent: "Asia",
    isContinent: false,
    value: "Singapore",
  },
  {
    label: "Sri Lanka",
    continent: "Asia",
    isContinent: false,
    value: "Sri Lanka",
  },
  {
    label: "Syrian Arab Republic",
    continent: "Asia",
    isContinent: false,
    value: "Syrian Arab Republic",
  },
  {
    label: "Taiwan",
    continent: "Asia",
    isContinent: false,
    value: "Taiwan",
  },
  {
    label: "Tajikistan",
    continent: "Asia",
    isContinent: false,
    value: "Tajikistan",
  },
  {
    label: "Thailand",
    continent: "Asia",
    isContinent: false,
    value: "Thailand",
  },
  {
    label: "Timor-Leste",
    continent: "Asia",
    isContinent: false,
    value: "Timor-Leste",
  },
  {
    label: "Turkey",
    continent: "Asia",
    isContinent: false,
    value: "Turkey",
  },
  {
    label: "Turkmenistan",
    continent: "Asia",
    isContinent: false,
    value: "Turkmenistan",
  },
  {
    label: "United Arab Emirates",
    continent: "Asia",
    isContinent: false,
    value: "United Arab Emirates",
  },
  {
    label: "Uzbekistan",
    continent: "Asia",
    isContinent: false,
    value: "Uzbekistan",
  },
  {
    label: "Vietnam",
    continent: "Asia",
    isContinent: false,
    value: "Vietnam",
  },
  {
    label: "Yemen",
    continent: "Asia",
    isContinent: false,
    value: "Yemen",
  },

  // Americas (North America & South America)

  // North America
  {
    label: "North America",
    continent: "North America",
    isContinent: true,
    value: "North America",
  },
  {
    label: "Antigua and Barbuda",
    continent: "North America",
    isContinent: false,
    value: "Antigua and Barbuda",
  },
  {
    label: "Anguilla",
    continent: "North America",
    isContinent: false,
    value: "Anguilla",
  },
  {
    label: "Aruba",
    continent: "North America",
    isContinent: false,
    value: "Aruba",
  },
  {
    label: "Barbados",
    continent: "North America",
    isContinent: false,
    value: "Barbados",
  },
  {
    label: "Bermuda",
    continent: "North America",
    isContinent: false,
    value: "Bermuda",
  },
  {
    label: "Bahamas",
    continent: "North America",
    isContinent: false,
    value: "Bahamas",
  },
  {
    label: "Belize",
    continent: "North America",
    isContinent: false,
    value: "Belize",
  },
  {
    label: "Canada",
    suggested: true,
    continent: "North America",
    isContinent: false,
    value: "Canada",
  },
  {
    label: "Costa Rica",
    continent: "North America",
    isContinent: false,
    value: "Costa Rica",
  },
  {
    label: "Cuba",
    continent: "North America",
    isContinent: false,
    value: "Cuba",
  },
  {
    label: "Curacao",
    continent: "North America",
    isContinent: false,
    value: "Curacao",
  },
  {
    label: "Dominica",
    continent: "North America",
    isContinent: false,
    value: "Dominica",
  },
  {
    label: "Dominican Republic",
    continent: "North America",
    isContinent: false,
    value: "Dominican Republic",
  },
  {
    label: "El Salvador",
    continent: "North America",
    isContinent: false,
    value: "El Salvador",
  },
  {
    label: "Grenada",
    continent: "North America",
    isContinent: false,
    value: "Grenada",
  },
  {
    label: "Greenland",
    continent: "North America",
    isContinent: false,
    value: "Greenland",
  },
  {
    label: "Guadeloupe",
    continent: "North America",
    isContinent: false,
    value: "Guadeloupe",
  },
  {
    label: "Guatemala",
    continent: "North America",
    isContinent: false,
    value: "Guatemala",
  },
  {
    label: "Honduras",
    continent: "North America",
    isContinent: false,
    value: "Honduras",
  },
  {
    label: "Haiti",
    continent: "North America",
    isContinent: false,
    value: "Haiti",
  },
  {
    label: "Jamaica",
    continent: "North America",
    isContinent: false,
    value: "Jamaica",
  },
  {
    label: "Cayman Islands",
    continent: "North America",
    isContinent: false,
    value: "Cayman Islands",
  },
  {
    label: "Saint Lucia",
    continent: "North America",
    isContinent: false,
    value: "Saint Lucia",
  },
  {
    label: "Saint Martin (French part)",
    continent: "North America",
    isContinent: false,
    value: "Saint Martin (French part)",
  },
  {
    label: "Martinique",
    continent: "North America",
    isContinent: false,
    value: "Martinique",
  },
  {
    label: "Montserrat",
    continent: "North America",
    isContinent: false,
    value: "Montserrat",
  },
  {
    label: "Mexico",
    continent: "North America",
    isContinent: false,
    value: "Mexico",
  },
  {
    label: "Nicaragua",
    continent: "North America",
    isContinent: false,
    value: "Nicaragua",
  },
  {
    label: "Panama",
    continent: "North America",
    isContinent: false,
    value: "Panama",
  },
  {
    label: "Saint Pierre and Miquelon",
    continent: "North America",
    isContinent: false,
    value: "Saint Pierre and Miquelon",
  },
  {
    label: "Puerto Rico",
    continent: "North America",
    isContinent: false,
    value: "Puerto Rico",
  },
  {
    label: "Saint Barthelemy",
    continent: "North America",
    isContinent: false,
    value: "Saint Barthelemy",
  },
  {
    label: "Saint Kitts and Nevis",
    continent: "North America",
    isContinent: false,
    value: "Saint Kitts and Nevis",
  },
  {
    label: "Sint Maarten (Dutch part)",
    continent: "North America",
    isContinent: false,
    value: "Sint Maarten (Dutch part)",
  },
  {
    label: "Turks and Caicos Islands",
    continent: "North America",
    isContinent: false,
    value: "Turks and Caicos Islands",
  },
  {
    label: "Trinidad and Tobago",
    continent: "North America",
    isContinent: false,
    value: "Trinidad and Tobago",
  },
  {
    label: "United States",
    suggested: true,
    continent: "North America",
    isContinent: false,
    value: "United States",
  },
  {
    label: "Saint Vincent and the Grenadines",
    continent: "North America",
    isContinent: false,
    value: "Saint Vincent and the Grenadines",
  },
  {
    label: "British Virgin Islands",
    continent: "North America",
    isContinent: false,
    value: "British Virgin Islands",
  },
  {
    label: "US Virgin Islands",
    continent: "North America",
    isContinent: false,
    value: "US Virgin Islands",
  },

  // South America
  {
    label: "South America",
    continent: "South America",
    isContinent: true,
    value: "South America",
  },
  {
    label: "Argentina",
    continent: "South America",
    isContinent: false,
    value: "Argentina",
  },
  {
    label: "Bolivia",
    continent: "South America",
    isContinent: false,
    value: "Bolivia",
  },
  {
    label: "Brazil",
    continent: "South America",
    isContinent: false,
    value: "Brazil",
  },
  {
    label: "Chile",
    continent: "South America",
    isContinent: false,
    value: "Chile",
  },
  {
    label: "Colombia",
    continent: "South America",
    isContinent: false,
    value: "Colombia",
  },
  {
    label: "Ecuador",
    continent: "South America",
    isContinent: false,
    value: "Ecuador",
  },
  {
    label: "Falkland Islands (Malvinas)",
    continent: "South America",
    isContinent: false,
    value: "Falkland Islands (Malvinas)",
  },
  {
    label: "French Guiana",
    continent: "South America",
    isContinent: false,
    value: "French Guiana",
  },
  {
    label: "Guyana",
    continent: "South America",
    isContinent: false,
    value: "Guyana",
  },
  {
    label: "Paraguay",
    continent: "South America",
    isContinent: false,
    value: "Paraguay",
  },
  {
    label: "Peru",
    continent: "South America",
    isContinent: false,
    value: "Peru",
  },
  {
    label: "Suriname",
    continent: "South America",
    isContinent: false,
    value: "Suriname",
  },
  {
    label: "Uruguay",
    continent: "South America",
    isContinent: false,
    value: "Uruguay",
  },
  {
    label: "Venezuela",
    continent: "South America",
    isContinent: false,
    value: "Venezuela",
  },

  // Europe
  {
    label: "Europe",
    continent: "Europe",
    isContinent: true,
    value: "Europe",
  },
  {
    label: "Albania",
    continent: "Europe",
    isContinent: false,
    value: "Albania",
  },
  {
    label: "Alland Islands",
    continent: "Europe",
    isContinent: false,
    value: "Alland Islands",
  },
  {
    label: "Andorra",
    continent: "Europe",
    isContinent: false,
    value: "Andorra",
  },
  {
    label: "Austria",
    continent: "Europe",
    isContinent: false,
    value: "Austria",
  },
  {
    label: "Belarus",
    continent: "Europe",
    isContinent: false,
    value: "Belarus",
  },
  {
    label: "Belgium",
    continent: "Europe",
    isContinent: false,
    value: "Belgium",
  },
  {
    label: "Bosnia and Herzegovina",
    continent: "Europe",
    isContinent: false,
    value: "Bosnia and Herzegovina",
  },
  {
    label: "Bulgaria",
    continent: "Europe",
    isContinent: false,
    value: "Bulgaria",
  },
  {
    label: "Croatia",
    continent: "Europe",
    isContinent: false,
    value: "Croatia",
  },
  {
    label: "Cyprus",
    continent: "Asia",
    isContinent: false,
    value: "Cyprus",
  },
  {
    label: "Czech Republic",
    continent: "Europe",
    isContinent: false,
    value: "Czech Republic",
  },
  {
    label: "Denmark",
    continent: "Europe",
    isContinent: false,
    value: "Denmark",
  },
  {
    label: "Estonia",
    continent: "Europe",
    isContinent: false,
    value: "Estonia",
  },
  {
    label: "Faroe Islands",
    continent: "Europe",
    isContinent: false,
    value: "Faroe Islands",
  },
  {
    label: "Finland",
    continent: "Europe",
    isContinent: false,
    value: "Finland",
  },
  {
    label: "France",
    suggested: true,
    continent: "Europe",
    isContinent: false,
    value: "France",
  },
  {
    label: "Germany",
    suggested: true,
    continent: "Europe",
    isContinent: false,
    value: "Germany",
  },
  {
    label: "Gibraltar",
    continent: "Europe",
    isContinent: false,
    value: "Gibraltar",
  },
  {
    label: "Greece",
    continent: "Europe",
    isContinent: false,
    value: "Greece",
  },
  {
    label: "Guernsey",
    continent: "Europe",
    isContinent: false,
    value: "Guernsey",
  },
  {
    label: "Holy See (Vatican City State)",
    continent: "Europe",
    isContinent: false,
    value: "Holy See (Vatican City State)",
  },
  {
    label: "Hungary",
    continent: "Europe",
    isContinent: false,
    value: "Hungary",
  },
  {
    label: "Iceland",
    continent: "Europe",
    isContinent: false,
    value: "Iceland",
  },
  {
    label: "Ireland",
    continent: "Europe",
    isContinent: false,
    value: "Ireland",
  },
  {
    label: "Isle of Man",
    continent: "Europe",
    isContinent: false,
    value: "Isle of Man",
  },
  {
    label: "Italy",
    continent: "Europe",
    isContinent: false,
    value: "Italy",
  },
  {
    label: "Jersey",
    continent: "Europe",
    isContinent: false,
    value: "Jersey",
  },
  {
    label: "Kosovo",
    continent: "Europe",
    isContinent: false,
    value: "Kosovo",
  },
  {
    label: "Latvia",
    continent: "Europe",
    isContinent: false,
    value: "Latvia",
  },
  {
    label: "Liechtenstein",
    continent: "Europe",
    isContinent: false,
    value: "Liechtenstein",
  },
  {
    label: "Lithuania",
    continent: "Europe",
    isContinent: false,
    value: "Lithuania",
  },
  {
    label: "Luxembourg",
    continent: "Europe",
    isContinent: false,
    value: "Luxembourg",
  },
  {
    label: "Macedonia, the Former Yugoslav Republic of",
    continent: "Europe",
    isContinent: false,
    value: "Macedonia, the Former Yugoslav Republic of",
  },
  {
    label: "Malta",
    continent: "Europe",
    isContinent: false,
    value: "Malta",
  },
  {
    label: "Moldova, Republic of",
    continent: "Europe",
    isContinent: false,
    value: "Moldova, Republic of",
  },
  {
    label: "Monaco",
    continent: "Europe",
    isContinent: false,
    value: "Monaco",
  },
  {
    label: "Montenegro",
    continent: "Europe",
    isContinent: false,
    value: "Montenegro",
  },
  {
    label: "Netherlands",
    continent: "Europe",
    isContinent: false,
    value: "Netherlands",
  },
  {
    label: "Norway",
    continent: "Europe",
    isContinent: false,
    value: "Norway",
  },
  {
    label: "Poland",
    continent: "Europe",
    isContinent: false,
    value: "Poland",
  },
  {
    label: "Portugal",
    continent: "Europe",
    isContinent: false,
    value: "Portugal",
  },
  {
    label: "Romania",
    continent: "Europe",
    isContinent: false,
    value: "Romania",
  },
  {
    label: "Russian Federation",
    continent: "Europe",
    isContinent: false,
    value: "Russian Federation",
  },
  {
    label: "San Marino",
    continent: "Europe",
    isContinent: false,
    value: "San Marino",
  },
  {
    label: "Serbia",
    continent: "Europe",
    isContinent: false,
    value: "Serbia",
  },
  {
    label: "Slovakia",
    continent: "Europe",
    isContinent: false,
    value: "Slovakia",
  },
  {
    label: "Slovenia",
    continent: "Europe",
    isContinent: false,
    value: "Slovenia",
  },
  {
    label: "Spain",
    continent: "Europe",
    isContinent: false,
    value: "Spain",
  },
  {
    label: "Svalbard and Jan Mayen",
    continent: "Europe",
    isContinent: false,
    value: "Svalbard and Jan Mayen",
  },
  {
    label: "Sweden",
    continent: "Europe",
    isContinent: false,
    value: "Sweden",
  },
  {
    label: "Switzerland",
    continent: "Europe",
    isContinent: false,
    value: "Switzerland",
  },
  {
    label: "Ukraine",
    continent: "Europe",
    isContinent: false,
    value: "Ukraine",
  },
  {
    label: "United Kingdom",
    continent: "Europe",
    isContinent: false,
    value: "United Kingdom",
  },

  // Africa
  {
    label: "Africa",
    continent: "Africa",
    isContinent: true,
    value: "Africa",
  },
  {
    label: "Angola",
    continent: "Africa",
    isContinent: false,
    value: "Angola",
  },
  {
    label: "Burkina Faso",
    continent: "Africa",
    isContinent: false,
    value: "Burkina Faso",
  },
  {
    label: "Burundi",
    continent: "Africa",
    isContinent: false,
    value: "Burundi",
  },
  {
    label: "Benin",
    continent: "Africa",
    isContinent: false,
    value: "Benin",
  },
  {
    label: "Botswana",
    continent: "Africa",
    isContinent: false,
    value: "Botswana",
  },
  {
    label: "Democratic Republic of the Congo",
    continent: "Africa",
    isContinent: false,
    value: "Democratic Republic of the Congo",
  },
  {
    label: "Central African Republic",
    continent: "Africa",
    isContinent: false,
    value: "Central African Republic",
  },
  {
    label: "Republic of the Congo",
    continent: "Africa",
    isContinent: false,
    value: "Republic of the Congo",
  },
  {
    label: "Cote d'Ivoire",
    continent: "Africa",
    isContinent: false,
    value: "Cote d'Ivoire",
  },
  {
    label: "Cameroon",
    continent: "Africa",
    isContinent: false,
    value: "Cameroon",
  },
  {
    label: "Cape Verde",
    continent: "Africa",
    isContinent: false,
    value: "Cape Verde",
  },
  {
    label: "Djibouti",
    continent: "Africa",
    isContinent: false,
    value: "Djibouti",
  },
  {
    label: "Algeria",
    continent: "Africa",
    isContinent: false,
    value: "Algeria",
  },
  {
    label: "Egypt",
    continent: "Africa",
    isContinent: false,
    value: "Egypt",
  },
  {
    label: "Western Sahara",
    continent: "Africa",
    isContinent: false,
    value: "Western Sahara",
  },
  {
    label: "Eritrea",
    continent: "Africa",
    isContinent: false,
    value: "Eritrea",
  },
  {
    label: "Ethiopia",
    continent: "Africa",
    isContinent: false,
    value: "Ethiopia",
  },
  {
    label: "Gabon",
    continent: "Africa",
    isContinent: false,
    value: "Gabon",
  },
  {
    label: "Ghana",
    continent: "Africa",
    isContinent: false,
    value: "Ghana",
  },
  {
    label: "Gambia",
    continent: "Africa",
    isContinent: false,
    value: "Gambia",
  },
  {
    label: "Guinea",
    continent: "Africa",
    isContinent: false,
    value: "Guinea",
  },
  {
    label: "Equatorial Guinea",
    continent: "Africa",
    isContinent: false,
    value: "Equatorial Guinea",
  },
  {
    label: "Guinea-Bissau",
    continent: "Africa",
    isContinent: false,
    value: "Guinea-Bissau",
  },
  {
    label: "Kenya",
    continent: "Africa",
    isContinent: false,
    value: "Kenya",
  },
  {
    label: "Comoros",
    continent: "Africa",
    isContinent: false,
    value: "Comoros",
  },
  {
    label: "Liberia",
    continent: "Africa",
    isContinent: false,
    value: "Liberia",
  },
  {
    label: " Lesotho",
    continent: "Africa",
    isContinent: false,
    value: "Lesotho",
  },
  {
    label: "Libya",
    continent: "Africa",
    isContinent: false,
    value: "Libya",
  },
  {
    label: "Morocco",
    continent: "Africa",
    isContinent: false,
    value: "Morocco",
  },
  {
    label: "Madagascar",
    continent: "Africa",
    isContinent: false,
    value: "Madagascar",
  },
  {
    label: "Mali",
    continent: "Africa",
    isContinent: false,
    value: "Mali",
  },
  {
    label: "Mauritania",
    continent: "Africa",
    isContinent: false,
    value: "Mauritania",
  },
  {
    label: "Mauritius",
    continent: "Africa",
    isContinent: false,
    value: "Mauritius",
  },
  {
    label: "Malawi",
    continent: "Africa",
    isContinent: false,
    value: "Malawi",
  },
  {
    label: "Mozambique",
    continent: "Africa",
    isContinent: false,
    value: "Mozambique",
  },
  {
    label: "Namibia",
    continent: "Africa",
    isContinent: false,
    value: "Namibia",
  },
  {
    label: "Niger",
    continent: "Africa",
    isContinent: false,
    value: "Niger",
  },
  {
    label: "Nigeria",
    continent: "Africa",
    isContinent: false,
    value: "Nigeria",
  },
  {
    label: "Reunion",
    continent: "Africa",
    isContinent: false,
    value: "Reunion",
  },
  {
    label: "Rwanda",
    continent: "Africa",
    isContinent: false,
    value: "Rwanda",
  },
  {
    label: "Seychelles",
    continent: "Africa",
    isContinent: false,
    value: "Seychelles",
  },
  {
    label: "Sudan",
    continent: "Africa",
    isContinent: false,
    value: "Sudan",
  },
  {
    label: "Saint Helena",
    continent: "Africa",
    isContinent: false,
    value: "Saint Helena",
  },
  {
    label: "Sierra Leone",
    continent: "Africa",
    isContinent: false,
    value: "Sierra Leone",
  },
  {
    label: "Senegal",
    continent: "Africa",
    isContinent: false,
    value: "Senegal",
  },
  {
    label: "Somalia",
    continent: "Africa",
    isContinent: false,
    value: "Somalia",
  },
  {
    label: "South Sudan",
    continent: "Africa",
    isContinent: false,
    value: "South Sudan",
  },
  {
    label: "Sao Tome and Principe",
    continent: "Africa",
    isContinent: false,
    value: "Sao Tome and Principe",
  },
  {
    label: "Swaziland",
    continent: "Africa",
    isContinent: false,
    value: "Swaziland",
  },
  {
    label: "Chad",
    continent: "Africa",
    isContinent: false,
    value: "Chad",
  },
  {
    label: "Togo",
    continent: "Africa",
    isContinent: false,
    value: "Togo",
  },
  {
    label: "Tunisia",
    continent: "Africa",
    isContinent: false,
    value: "Tunisia",
  },
  {
    label: "United Republic of Tanzania",
    continent: "Africa",
    isContinent: false,
    value: "United Republic of Tanzania",
  },
  {
    label: "Uganda",
    continent: "Africa",
    isContinent: false,
    value: "Uganda",
  },
  {
    label: "Mayotte",
    continent: "Africa",
    isContinent: false,
    value: "Mayotte",
  },
  {
    label: "South Africa",
    continent: "Africa",
    isContinent: false,
    value: "South Africa",
  },
  {
    label: "Zambia",
    continent: "Africa",
    isContinent: false,
    value: "Zambia",
  },
  {
    label: "Zimbabwe",
    continent: "Africa",
    isContinent: false,
    value: "Zimbabwe",
  },

  // Oceania
  {
    label: "Oceania",
    continent: "Oceania",
    isContinent: true,
    value: "Oceania",
  },
  {
    label: "American Samoa",
    continent: "Oceania",
    isContinent: false,
    value: "American Samoa",
  },
  {
    label: "Australia",
    suggested: true,
    continent: "Oceania",
    isContinent: false,
    value: "Australia",
  },
  {
    label: "Cocos (Keeling) Islands",
    continent: "Oceania",
    isContinent: false,
    value: "Cocos (Keeling) Islands",
  },
  {
    label: "Cook Islands",
    continent: "Oceania",
    isContinent: false,
    value: "Cook Islands",
  },
  {
    label: "Christmas Island",
    continent: "Oceania",
    isContinent: false,
    value: "Christmas Island",
  },
  {
    label: "Fiji",
    continent: "Oceania",
    isContinent: false,
    value: "Fiji",
  },
  {
    label: "Micronesia, Federated States of",
    continent: "Oceania",
    isContinent: false,
    value: "Micronesia, Federated States of",
  },
  {
    label: "Guam",
    continent: "Oceania",
    isContinent: false,
    value: "Guam",
  },
  {
    label: "Heard Island and McDonald Islands",
    continent: "Oceania",
    isContinent: false,
    value: "Heard Island and McDonald Islands",
  },
  {
    label: "British Indian Ocean Territory",
    continent: "Oceania",
    isContinent: false,
    value: "British Indian Ocean Territory",
  },
  {
    label: "Kiribati",
    continent: "Oceania",
    isContinent: false,
    value: "Kiribati",
  },
  {
    label: "Marshall Islands",
    continent: "Oceania",
    isContinent: false,
    value: "Marshall Islands",
  },
  {
    label: "Northern Mariana Islands",
    continent: "Oceania",
    isContinent: false,
    value: "Northern Mariana Islands",
  },
  {
    label: "New Caledonia",
    continent: "Oceania",
    isContinent: false,
    value: "New Caledonia",
  },
  {
    label: "Norfolk Island",
    continent: "Oceania",
    isContinent: false,
    value: "Norfolk Island",
  },
  {
    label: "Nauru",
    continent: "Oceania",
    isContinent: false,
    value: "Nauru",
  },
  {
    label: "Niue",
    continent: "Oceania",
    isContinent: false,
    value: "Niue",
  },
  {
    label: "New Zealand",
    continent: "Oceania",
    isContinent: false,
    value: "New Zealand",
  },
  {
    label: "French Polynesia",
    continent: "Oceania",
    isContinent: false,
    value: "French Polynesia",
  },
  {
    label: "Papua New Guinea",
    continent: "Oceania",
    isContinent: false,
    value: "Papua New Guinea",
  },
  {
    label: "Pitcairn",
    continent: "Oceania",
    isContinent: false,
    value: "Pitcairn",
  },
  {
    label: "Palau",
    continent: "Oceania",
    isContinent: false,
    value: "Palau",
  },
  {
    label: "Solomon Islands",
    continent: "Oceania",
    isContinent: false,
    value: "Solomon Islands",
  },
  {
    label: "French Southern Territories",
    continent: "Oceania",
    isContinent: false,
    value: "French Southern Territories",
  },
  {
    label: "Tokelau",
    continent: "Oceania",
    isContinent: false,
    value: "Tokelau",
  },
  {
    label: "Tonga",
    continent: "Oceania",
    isContinent: false,
    value: "Tonga",
  },
  {
    label: "Tuvalu",
    continent: "Oceania",
    isContinent: false,
    value: "Tuvalu",
  },
  {
    label: "Vanuatu",
    continent: "Oceania",
    isContinent: false,
    value: "Vanuatu",
  },
  {
    label: "Wallis and Futuna",
    continent: "Oceania",
    isContinent: false,
    value: "Wallis and Futuna",
  },
  {
    label: "Samoa",
    continent: "Oceania",
    isContinent: false,
    value: "Samoa",
  },

  // Antarctica
  {
    label: "Antarctica",
    continent: "Antarctica",
    isContinent: true,
    value: "Antarctica",
  },
  {
    label: "Bouvet Island",
    continent: "Antarctica",
    isContinent: false,
    value: "Bouvet Island",
  },
  {
    label: "South Georgia and the South Sandwich Islands",
    continent: "Antarctica",
    isContinent: false,
    value: "South Georgia and the South Sandwich Islands",
  },
];

export const countryCodeWithContinents = [
  // Asia
  { label: "Asia", continent: "Asia", isContinent: true, value: "AS" },
  { label: "Afghanistan", continent: "Asia", isContinent: false, value: "AF" },
  { label: "Armenia", continent: "Asia", isContinent: false, value: "AM" },
  { label: "Azerbaijan", continent: "Asia", isContinent: false, value: "AZ" },
  { label: "Bahrain", continent: "Asia", isContinent: false, value: "BH" },
  { label: "Bangladesh", continent: "Asia", isContinent: false, value: "BD" },
  { label: "Bhutan", continent: "Asia", isContinent: false, value: "BT" },
  {
    label: "Brunei Darussalam",
    continent: "Asia",
    isContinent: false,
    value: "BN",
  },
  { label: "Cambodia", continent: "Asia", isContinent: false, value: "KH" },
  { label: "China", continent: "Asia", isContinent: false, value: "CN" },
  { label: "Georgia", continent: "Asia", isContinent: false, value: "GE" },
  { label: "Hong Kong", continent: "Asia", isContinent: false, value: "HK" },
  { label: "India", continent: "Asia", isContinent: false, value: "IN" },
  { label: "Indonesia", continent: "Asia", isContinent: false, value: "ID" },
  {
    label: "Iran, Islamic Republic of",
    continent: "Asia",
    isContinent: false,
    value: "IR",
  },
  { label: "Iraq", continent: "Asia", isContinent: false, value: "IQ" },
  { label: "Israel", continent: "Asia", isContinent: false, value: "IL" },
  {
    label: "Japan",
    suggested: true,
    continent: "Asia",
    isContinent: false,
    value: "JP",
  },
  { label: "Jordan", continent: "Asia", isContinent: false, value: "JO" },
  { label: "Kazakhstan", continent: "Asia", isContinent: false, value: "KZ" },
  {
    label: "Korea, Democratic People's Republic of",
    continent: "Asia",
    isContinent: false,
    value: "KP",
  },
  {
    label: "Korea, Republic of",
    continent: "Asia",
    isContinent: false,
    value: "KR",
  },
  { label: "Kuwait", continent: "Asia", isContinent: false, value: "KW" },
  { label: "Kyrgyzstan", continent: "Asia", isContinent: false, value: "KG" },
  {
    label: "Lao People's Democratic Republic",
    continent: "Asia",
    isContinent: false,
    value: "LA",
  },
  { label: "Lebanon", continent: "Asia", isContinent: false, value: "LB" },
  { label: "Macao", continent: "Asia", isContinent: false, value: "MO" },
  { label: "Malaysia", continent: "Asia", isContinent: false, value: "MY" },
  { label: "Maldives", continent: "Asia", isContinent: false, value: "MV" },
  { label: "Mongolia", continent: "Asia", isContinent: false, value: "MN" },
  { label: "Myanmar", continent: "Asia", isContinent: false, value: "MM" },
  { label: "Nepal", continent: "Asia", isContinent: false, value: "NP" },
  { label: "Oman", continent: "Asia", isContinent: false, value: "OM" },
  { label: "Pakistan", continent: "Asia", isContinent: false, value: "PK" },
  {
    label: "Palestine, State of",
    continent: "Asia",
    isContinent: false,
    value: "PS",
  },
  { label: "Philippines", continent: "Asia", isContinent: false, value: "PH" },
  { label: "Qatar", continent: "Asia", isContinent: false, value: "QA" },
  { label: "Saudi Arabia", continent: "Asia", isContinent: false, value: "SA" },
  { label: "Singapore", continent: "Asia", isContinent: false, value: "SG" },
  { label: "Sri Lanka", continent: "Asia", isContinent: false, value: "LK" },
  {
    label: "Syrian Arab Republic",
    continent: "Asia",
    isContinent: false,
    value: "SY",
  },
  { label: "Taiwan", continent: "Asia", isContinent: false, value: "TW" },
  { label: "Tajikistan", continent: "Asia", isContinent: false, value: "TJ" },
  { label: "Thailand", continent: "Asia", isContinent: false, value: "TH" },
  { label: "Timor-Leste", continent: "Asia", isContinent: false, value: "TL" },
  { label: "Turkey", continent: "Asia", isContinent: false, value: "TR" },
  { label: "Turkmenistan", continent: "Asia", isContinent: false, value: "TM" },
  {
    label: "United Arab Emirates",
    continent: "Asia",
    isContinent: false,
    value: "AE",
  },
  { label: "Uzbekistan", continent: "Asia", isContinent: false, value: "UZ" },
  { label: "Vietnam", continent: "Asia", isContinent: false, value: "VN" },
  { label: "Yemen", continent: "Asia", isContinent: false, value: "YE" },

  // Americas
  {
    label: "North America",
    continent: "North America",
    isContinent: true,
    value: "NA",
  },
  {
    label: "Antigua and Barbuda",
    continent: "North America",
    isContinent: false,
    value: "AG",
  },
  {
    label: "Anguilla",
    continent: "North America",
    isContinent: false,
    value: "AI",
  },
  {
    label: "Aruba",
    continent: "North America",
    isContinent: false,
    value: "AW",
  },
  {
    label: "Barbados",
    continent: "North America",
    isContinent: false,
    value: "BB",
  },
  {
    label: "Bermuda",
    continent: "North America",
    isContinent: false,
    value: "BM",
  },
  {
    label: "Bahamas",
    continent: "North America",
    isContinent: false,
    value: "BS",
  },
  {
    label: "Belize",
    continent: "North America",
    isContinent: false,
    value: "BZ",
  },
  {
    label: "Canada",
    suggested: true,
    continent: "North America",
    isContinent: false,
    value: "CA",
  },
  {
    label: "Costa Rica",
    continent: "North America",
    isContinent: false,
    value: "CR",
  },
  {
    label: "Cuba",
    continent: "North America",
    isContinent: false,
    value: "CU",
  },
  {
    label: "Curacao",
    continent: "North America",
    isContinent: false,
    value: "CW",
  },
  {
    label: "Dominica",
    continent: "North America",
    isContinent: false,
    value: "DM",
  },
  {
    label: "Dominican Republic",
    continent: "North America",
    isContinent: false,
    value: "DO",
  },
  {
    label: "El Salvador",
    continent: "North America",
    isContinent: false,
    value: "SV",
  },
  {
    label: "Grenada",
    continent: "North America",
    isContinent: false,
    value: "GD",
  },
  {
    label: "Greenland",
    continent: "North America",
    isContinent: false,
    value: "GL",
  },
  {
    label: "Guadeloupe",
    continent: "North America",
    isContinent: false,
    value: "GP",
  },
  {
    label: "Guatemala",
    continent: "North America",
    isContinent: false,
    value: "GT",
  },
  {
    label: "Honduras",
    continent: "North America",
    isContinent: false,
    value: "HN",
  },
  {
    label: "Haiti",
    continent: "North America",
    isContinent: false,
    value: "HT",
  },
  {
    label: "Jamaica",
    continent: "North America",
    isContinent: false,
    value: "JM",
  },
  {
    label: "Cayman Islands",
    continent: "North America",
    isContinent: false,
    value: "KY",
  },
  {
    label: "Saint Lucia",
    continent: "North America",
    isContinent: false,
    value: "LC",
  },
  {
    label: "Saint Martin (French part)",
    continent: "North America",
    isContinent: false,
    value: "MF",
  },
  {
    label: "Martinique",
    continent: "North America",
    isContinent: false,
    value: "MQ",
  },
  {
    label: "Montserrat",
    continent: "North America",
    isContinent: false,
    value: "MS",
  },
  {
    label: "Mexico",
    continent: "North America",
    isContinent: false,
    value: "MX",
  },
  {
    label: "Nicaragua",
    continent: "North America",
    isContinent: false,
    value: "NI",
  },
  {
    label: "Panama",
    continent: "North America",
    isContinent: false,
    value: "PA",
  },
  {
    label: "Saint Pierre and Miquelon",
    continent: "North America",
    isContinent: false,
    value: "PM",
  },
  {
    label: "Puerto Rico",
    continent: "North America",
    isContinent: false,
    value: "PR",
  },
  {
    label: "Saint Barthelemy",
    continent: "North America",
    isContinent: false,
    value: "BL",
  },
  {
    label: "Saint Kitts and Nevis",
    continent: "North America",
    isContinent: false,
    value: "KN",
  },
  {
    label: "Sint Maarten (Dutch part)",
    continent: "North America",
    isContinent: false,
    value: "SX",
  },
  {
    label: "Turks and Caicos Islands",
    continent: "North America",
    isContinent: false,
    value: "TC",
  },
  {
    label: "Trinidad and Tobago",
    continent: "North America",
    isContinent: false,
    value: "TT",
  },
  {
    label: "United States",
    suggested: true,
    continent: "North America",
    isContinent: false,
    value: "US",
  },
  {
    label: "Saint Vincent and the Grenadines",
    continent: "North America",
    isContinent: false,
    value: "VC",
  },
  {
    label: "British Virgin Islands",
    continent: "North America",
    isContinent: false,
    value: "VG",
  },
  {
    label: "US Virgin Islands",
    continent: "North America",
    isContinent: false,
    value: "VI",
  },

  {
    label: "South America",
    continent: "South America",
    isContinent: true,
    value: "SA",
  },
  {
    label: "Argentina",
    continent: "South America",
    isContinent: false,
    value: "AR",
  },
  {
    label: "Bolivia",
    continent: "South America",
    isContinent: false,
    value: "BO",
  },
  {
    label: "Brazil",
    continent: "South America",
    isContinent: false,
    value: "BR",
  },
  {
    label: "Chile",
    continent: "South America",
    isContinent: false,
    value: "CL",
  },
  {
    label: "Colombia",
    continent: "South America",
    isContinent: false,
    value: "CO",
  },
  {
    label: "Ecuador",
    continent: "South America",
    isContinent: false,
    value: "EC",
  },
  {
    label: "Falkland Islands (Malvinas)",
    continent: "South America",
    isContinent: false,
    value: "FK",
  },
  {
    label: "French Guiana",
    continent: "South America",
    isContinent: false,
    value: "GF",
  },
  {
    label: "Guyana",
    continent: "South America",
    isContinent: false,
    value: "GY",
  },
  {
    label: "Paraguay",
    continent: "South America",
    isContinent: false,
    value: "PY",
  },
  {
    label: "Peru",
    continent: "South America",
    isContinent: false,
    value: "PE",
  },
  {
    label: "Suriname",
    continent: "South America",
    isContinent: false,
    value: "SR",
  },
  {
    label: "Uruguay",
    continent: "South America",
    isContinent: false,
    value: "UY",
  },
  {
    label: "Venezuela",
    continent: "South America",
    isContinent: false,
    value: "VE",
  },

  // Europe
  { label: "Europe", continent: "Europe", isContinent: true, value: "EU" },
  { label: "Albania", continent: "Europe", isContinent: false, value: "AL" },
  {
    label: "Alland Islands",
    continent: "Europe",
    isContinent: false,
    value: "AX",
  }, // Åland Islands
  { label: "Andorra", continent: "Europe", isContinent: false, value: "AD" },
  { label: "Austria", continent: "Europe", isContinent: false, value: "AT" },
  { label: "Belarus", continent: "Europe", isContinent: false, value: "BY" },
  { label: "Belgium", continent: "Europe", isContinent: false, value: "BE" },
  {
    label: "Bosnia and Herzegovina",
    continent: "Europe",
    isContinent: false,
    value: "BA",
  },
  { label: "Bulgaria", continent: "Europe", isContinent: false, value: "BG" },
  { label: "Croatia", continent: "Europe", isContinent: false, value: "HR" },
  { label: "Cyprus", continent: "Asia", isContinent: false, value: "CY" },
  {
    label: "Czech Republic",
    continent: "Europe",
    isContinent: false,
    value: "CZ",
  },
  { label: "Denmark", continent: "Europe", isContinent: false, value: "DK" },
  { label: "Estonia", continent: "Europe", isContinent: false, value: "EE" },
  {
    label: "Faroe Islands",
    continent: "Europe",
    isContinent: false,
    value: "FO",
  },
  { label: "Finland", continent: "Europe", isContinent: false, value: "FI" },
  {
    label: "France",
    suggested: true,
    continent: "Europe",
    isContinent: false,
    value: "FR",
  },
  {
    label: "Germany",
    suggested: true,
    continent: "Europe",
    isContinent: false,
    value: "DE",
  },
  { label: "Gibraltar", continent: "Europe", isContinent: false, value: "GI" },
  { label: "Greece", continent: "Europe", isContinent: false, value: "GR" },
  { label: "Guernsey", continent: "Europe", isContinent: false, value: "GG" },
  {
    label: "Holy See (Vatican City State)",
    continent: "Europe",
    isContinent: false,
    value: "VA",
  },
  { label: "Hungary", continent: "Europe", isContinent: false, value: "HU" },
  { label: "Iceland", continent: "Europe", isContinent: false, value: "IS" },
  { label: "Ireland", continent: "Europe", isContinent: false, value: "IE" },
  {
    label: "Isle of Man",
    continent: "Europe",
    isContinent: false,
    value: "IM",
  },
  { label: "Italy", continent: "Europe", isContinent: false, value: "IT" },
  { label: "Jersey", continent: "Europe", isContinent: false, value: "JE" },
  { label: "Kosovo", continent: "Europe", isContinent: false, value: "XK" },
  { label: "Latvia", continent: "Europe", isContinent: false, value: "LV" },
  {
    label: "Liechtenstein",
    continent: "Europe",
    isContinent: false,
    value: "LI",
  },
  { label: "Lithuania", continent: "Europe", isContinent: false, value: "LT" },
  { label: "Luxembourg", continent: "Europe", isContinent: false, value: "LU" },
  {
    label: "Macedonia, the Former Yugoslav Republic of",
    continent: "Europe",
    isContinent: false,
    value: "MK",
  },
  { label: "Malta", continent: "Europe", isContinent: false, value: "MT" },
  {
    label: "Moldova, Republic of",
    continent: "Europe",
    isContinent: false,
    value: "MD",
  },
  { label: "Monaco", continent: "Europe", isContinent: false, value: "MC" },
  { label: "Montenegro", continent: "Europe", isContinent: false, value: "ME" },
  {
    label: "Netherlands",
    continent: "Europe",
    isContinent: false,
    value: "NL",
  },
  { label: "Norway", continent: "Europe", isContinent: false, value: "NO" },
  { label: "Poland", continent: "Europe", isContinent: false, value: "PL" },
  { label: "Portugal", continent: "Europe", isContinent: false, value: "PT" },
  { label: "Romania", continent: "Europe", isContinent: false, value: "RO" },
  {
    label: "Russian Federation",
    continent: "Europe",
    isContinent: false,
    value: "RU",
  },
  { label: "San Marino", continent: "Europe", isContinent: false, value: "SM" },
  { label: "Serbia", continent: "Europe", isContinent: false, value: "RS" },
  { label: "Slovakia", continent: "Europe", isContinent: false, value: "SK" },
  { label: "Slovenia", continent: "Europe", isContinent: false, value: "SI" },
  { label: "Spain", continent: "Europe", isContinent: false, value: "ES" },
  {
    label: "Svalbard and Jan Mayen",
    continent: "Europe",
    isContinent: false,
    value: "SJ",
  },
  { label: "Sweden", continent: "Europe", isContinent: false, value: "SE" },
  {
    label: "Switzerland",
    continent: "Europe",
    isContinent: false,
    value: "CH",
  },
  { label: "Ukraine", continent: "Europe", isContinent: false, value: "UA" },
  {
    label: "United Kingdom",
    continent: "Europe",
    isContinent: false,
    value: "GB",
  },

  // Africa
  { label: "Africa", continent: "Africa", isContinent: true, value: "AF" },
  { label: "Angola", continent: "Africa", isContinent: false, value: "AO" },
  {
    label: "Burkina Faso",
    continent: "Africa",
    isContinent: false,
    value: "BF",
  },
  { label: "Burundi", continent: "Africa", isContinent: false, value: "BI" },
  { label: "Benin", continent: "Africa", isContinent: false, value: "BJ" },
  { label: "Botswana", continent: "Africa", isContinent: false, value: "BW" },
  {
    label: "Democratic Republic of the Congo",
    continent: "Africa",
    isContinent: false,
    value: "CD",
  },
  {
    label: "Central African Republic",
    continent: "Africa",
    isContinent: false,
    value: "CF",
  },
  {
    label: "Republic of the Congo",
    continent: "Africa",
    isContinent: false,
    value: "CG",
  },
  {
    label: "Cote d'Ivoire",
    continent: "Africa",
    isContinent: false,
    value: "CI",
  },
  { label: "Cameroon", continent: "Africa", isContinent: false, value: "CM" },
  { label: "Cape Verde", continent: "Africa", isContinent: false, value: "CV" },
  { label: "Djibouti", continent: "Africa", isContinent: false, value: "DJ" },
  { label: "Algeria", continent: "Africa", isContinent: false, value: "DZ" },
  { label: "Egypt", continent: "Africa", isContinent: false, value: "EG" },
  {
    label: "Western Sahara",
    continent: "Africa",
    isContinent: false,
    value: "EH",
  },
  { label: "Eritrea", continent: "Africa", isContinent: false, value: "ER" },
  { label: "Ethiopia", continent: "Africa", isContinent: false, value: "ET" },
  { label: "Gabon", continent: "Africa", isContinent: false, value: "GA" },
  { label: "Ghana", continent: "Africa", isContinent: false, value: "GH" },
  { label: "Gambia", continent: "Africa", isContinent: false, value: "GM" },
  { label: "Guinea", continent: "Africa", isContinent: false, value: "GN" },
  {
    label: "Equatorial Guinea",
    continent: "Africa",
    isContinent: false,
    value: "GQ",
  },
  {
    label: "Guinea-Bissau",
    continent: "Africa",
    isContinent: false,
    value: "GW",
  },
  { label: "Kenya", continent: "Africa", isContinent: false, value: "KE" },
  { label: "Comoros", continent: "Africa", isContinent: false, value: "KM" },
  { label: "Liberia", continent: "Africa", isContinent: false, value: "LR" },
  { label: "Lesotho", continent: "Africa", isContinent: false, value: "LS" },
  { label: "Libya", continent: "Africa", isContinent: false, value: "LY" },
  { label: "Morocco", continent: "Africa", isContinent: false, value: "MA" },
  { label: "Madagascar", continent: "Africa", isContinent: false, value: "MG" },
  { label: "Mali", continent: "Africa", isContinent: false, value: "ML" },
  { label: "Mauritania", continent: "Africa", isContinent: false, value: "MR" },
  { label: "Mauritius", continent: "Africa", isContinent: false, value: "MU" },
  { label: "Malawi", continent: "Africa", isContinent: false, value: "MW" },
  { label: "Mozambique", continent: "Africa", isContinent: false, value: "MZ" },
  { label: "Namibia", continent: "Africa", isContinent: false, value: "NA" },
  { label: "Niger", continent: "Africa", isContinent: false, value: "NE" },
  { label: "Nigeria", continent: "Africa", isContinent: false, value: "NG" },
  { label: "Reunion", continent: "Africa", isContinent: false, value: "RE" },
  { label: "Rwanda", continent: "Africa", isContinent: false, value: "RW" },
  { label: "Seychelles", continent: "Africa", isContinent: false, value: "SC" },
  { label: "Sudan", continent: "Africa", isContinent: false, value: "SD" },
  {
    label: "Saint Helena",
    continent: "Africa",
    isContinent: false,
    value: "SH",
  },
  {
    label: "Sierra Leone",
    continent: "Africa",
    isContinent: false,
    value: "SL",
  },
  { label: "Senegal", continent: "Africa", isContinent: false, value: "SN" },
  { label: "Somalia", continent: "Africa", isContinent: false, value: "SO" },
  {
    label: "South Sudan",
    continent: "Africa",
    isContinent: false,
    value: "SS",
  },
  {
    label: "Sao Tome and Principe",
    continent: "Africa",
    isContinent: false,
    value: "ST",
  },
  { label: "Swaziland", continent: "Africa", isContinent: false, value: "SZ" },
  { label: "Chad", continent: "Africa", isContinent: false, value: "TD" },
  { label: "Togo", continent: "Africa", isContinent: false, value: "TG" },
  { label: "Tunisia", continent: "Africa", isContinent: false, value: "TN" },
  {
    label: "United Republic of Tanzania",
    continent: "Africa",
    isContinent: false,
    value: "TZ",
  },
  { label: "Uganda", continent: "Africa", isContinent: false, value: "UG" },
  { label: "Mayotte", continent: "Africa", isContinent: false, value: "YT" },
  {
    label: "South Africa",
    continent: "Africa",
    isContinent: false,
    value: "ZA",
  },
  { label: "Zambia", continent: "Africa", isContinent: false, value: "ZM" },
  { label: "Zimbabwe", continent: "Africa", isContinent: false, value: "ZW" },

  // Oceania
  { label: "Oceania", continent: "Oceania", isContinent: true, value: "OC" },
  {
    label: "American Samoa",
    continent: "Oceania",
    isContinent: false,
    value: "AS",
  },
  {
    label: "Australia",
    suggested: true,
    continent: "Oceania",
    isContinent: false,
    value: "AU",
  },
  {
    label: "Cocos (Keeling) Islands",
    continent: "Oceania",
    isContinent: false,
    value: "CC",
  },
  {
    label: "Cook Islands",
    continent: "Oceania",
    isContinent: false,
    value: "CK",
  },
  {
    label: "Christmas Island",
    continent: "Oceania",
    isContinent: false,
    value: "CX",
  },
  { label: "Fiji", continent: "Oceania", isContinent: false, value: "FJ" },
  {
    label: "Micronesia, Federated States of",
    continent: "Oceania",
    isContinent: false,
    value: "FM",
  },
  { label: "Guam", continent: "Oceania", isContinent: false, value: "GU" },
  {
    label: "Heard Island and McDonald Islands",
    continent: "Oceania",
    isContinent: false,
    value: "HM",
  },
  {
    label: "British Indian Ocean Territory",
    continent: "Oceania",
    isContinent: false,
    value: "IO",
  },
  { label: "Kiribati", continent: "Oceania", isContinent: false, value: "KI" },
  {
    label: "Marshall Islands",
    continent: "Oceania",
    isContinent: false,
    value: "MH",
  },
  {
    label: "Northern Mariana Islands",
    continent: "Oceania",
    isContinent: false,
    value: "MP",
  },
  {
    label: "New Caledonia",
    continent: "Oceania",
    isContinent: false,
    value: "NC",
  },
  {
    label: "Norfolk Island",
    continent: "Oceania",
    isContinent: false,
    value: "NF",
  },
  { label: "Nauru", continent: "Oceania", isContinent: false, value: "NR" },
  { label: "Niue", continent: "Oceania", isContinent: false, value: "NU" },
  {
    label: "New Zealand",
    continent: "Oceania",
    isContinent: false,
    value: "NZ",
  },
  {
    label: "French Polynesia",
    continent: "Oceania",
    isContinent: false,
    value: "PF",
  },
  {
    label: "Papua New Guinea",
    continent: "Oceania",
    isContinent: false,
    value: "PG",
  },
  { label: "Pitcairn", continent: "Oceania", isContinent: false, value: "PN" },
  { label: "Palau", continent: "Oceania", isContinent: false, value: "PW" },
  {
    label: "Solomon Islands",
    continent: "Oceania",
    isContinent: false,
    value: "SB",
  },
  {
    label: "French Southern Territories",
    continent: "Oceania",
    isContinent: false,
    value: "TF",
  },
  { label: "Tokelau", continent: "Oceania", isContinent: false, value: "TK" },
  { label: "Tonga", continent: "Oceania", isContinent: false, value: "TO" },
  { label: "Tuvalu", continent: "Oceania", isContinent: false, value: "TV" },
  { label: "Vanuatu", continent: "Oceania", isContinent: false, value: "VU" },
  {
    label: "Wallis and Futuna",
    continent: "Oceania",
    isContinent: false,
    value: "WF",
  },
  { label: "Samoa", continent: "Oceania", isContinent: false, value: "WS" },

  // Antarctica
  {
    label: "Antarctica",
    continent: "Antarctica",
    isContinent: true,
    value: "AQ",
  },
  {
    label: "Bouvet Island",
    continent: "Antarctica",
    isContinent: false,
    value: "BV",
  },
  {
    label: "South Georgia and the South Sandwich Islands",
    continent: "Antarctica",
    isContinent: false,
    value: "GS",
  },
];
